var axios = require('axios')
var numbro = require('numbro')

export default {
  filters: {
    /**
     * Filter to truncate string, accepts a length parameter
     */
    truncate (value, length) {
      return value.length > length
        ? value.substr(0, length) + '...'
        : value
    },
    currency (value, length) {
      return numbro(value).formatCurrency('$ 0,0[.]00')
    },
    whole_number (value, length) {
      if (!value) { return '' }
      return numbro(value).format('(0,0a')
    },
    rounded_number (value) {
      return numbro(value).format('(0,0.00a')
    },
    percent (value, length) {
      var val = ''
      if (value && value != 0) {
        return numbro(value / 100.0).format('(0.000%')
      }
      return val
    },
    date (value, length) {
      if (value && (value instanceof Date)) { return value.toLocaleDateString() } else if (value) { return new Date(value).toLocaleDateString() }
      return ''
    },
    datetime (value, length) {
      if (value && (value instanceof Date)) { return value.toLocaleDateString() + ' ' + value.toLocaleTimeString() } else if (value) { return value.replace('.000Z', '') }// new Date(value).toLocaleDateString()+" "+new Date(value).toLocaleTimeString();
      return ''
    }
  }
}
